export const load = () => ({
	title: 'About Indow',
	description:
		'Indow is a Portland-based window inserts company providing quiet and comfort to homes and businesses throughout the US & Canada.',
	showTitle: true,
});
